import React from 'react';
import PropTypes from 'prop-types';
import ActivismTickIcon from '../../../../public/static/icons/activism-tick.svg';
import BulletPointBackgroundIcon from '../../../../public/static/icons/bullet-point-background.svg';
import FormattedText from '../../../01_atoms/FormattedText';
import styles from './index.module.scss';

const BBCollageWithBulletPoints = ({
  uuid,
  heading = '',
  bulletPointType,
  style,
  collage,
  items,
}) => (
  <div className={`bb ${styles['bb-collage-with-bullet-points']}`} id={uuid}>
    <div className="container">
      {heading && <h2 className={styles['bb-collage-with-bullet-points__heading']}>{heading}</h2>}
      <div className={styles['bb-collage-with-bullet-points__content']}>
        <div className={styles['bb-collage-with-bullet-points__collage-wrapper']}>
          <div className={styles['collage']} role="img" aria-label={collage.alt}>
            {collage.images.map((item, index) => (
              <div
                className={`${styles['collage__item']} ${
                  styles[`collage__item--item-${index + 1}`]
                }`}
                key={`collage-item-${index}`}
              >
                <img src={item.url} loading="lazy" alt="" width={236} height={175} />
              </div>
            ))}
          </div>
        </div>
        <div className={styles['bb-collage-with-bullet-points__items']}>
          {items.map((item, index) => (
            <div
              className={styles['bb-collage-with-bullet-points__item']}
              key={`${item.title}-${index}`}
            >
              <div className={styles['bullet-point']}>
                <BulletPointBackgroundIcon
                  className={styles[`bullet-point__background--${style}`]}
                />
                <div className={styles['bullet-point__inner']}>
                  {bulletPointType === 'digit' && (
                    <div className={styles[`bullet-point__inner--${bulletPointType}`]}>
                      {index + 1}
                    </div>
                  )}
                  {bulletPointType === 'tick' && (
                    <ActivismTickIcon
                      className={styles[`bullet-point__inner--${bulletPointType}`]}
                    />
                  )}
                </div>
              </div>
              <h3 className={styles['bb-collage-with-bullet-points__title']}>{item.title}</h3>
              <FormattedText
                text={item.text}
                className={styles['bb-collage-with-bullet-points__text']}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

BBCollageWithBulletPoints.propTypes = {
  uuid: PropTypes.string.isRequired,
  heading: PropTypes.string,
  bulletPointType: PropTypes.oneOf(['digit', 'tick']).isRequired,
  style: PropTypes.oneOf(['normal', 'activism']).isRequired,
  collage: PropTypes.shape({
    images: PropTypes.arrayOf(
      PropTypes.shape({
        alt: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    alt: PropTypes.string,
  }).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      text: PropTypes.string,
    }),
  ).isRequired,
};

export default BBCollageWithBulletPoints;
